<script>
	import formBase from '@_system/components/base/form.vue'
	import bankaccbox from './box/bankacc.vue'
	import rcvaccbox from './box/rcvacc.vue'
	import jindieform from '../costorder/jindie/form.vue'
	export default {
		extends: formBase,
		name: 'formalcostorderForm',
		props: {

		},
		data() {
			return {
				costobj:null,
				businessstaffid:null,
				isauto:true,
				maindata:null,
				tabledata:[],
				jindierequire:null
			}

		},
		render(h) {
			this.$slots.plug = [
				<bankaccbox ref = "bankaccbox" onBack = {this.bankaccboxBack}
					onSubmit = {this.bankaccboxSubmit}
					onBoxdataload = {this.bankaccboxload}/>,
				<rcvaccbox ref = "rcvaccbox" onBack = {this.rcvaccboxBack}
					onSubmit = {this.rcvaccboxSubmit}
					onBoxdataload = {this.rcvaccboxload} costobj = {this.costobj} businessstaffid={this.businessstaffid} />,	
				<jindieform ref = "jindieform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,		
			]
			return formBase.render.call(this, h)
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeSubmit(formData, next) {
				formData.jindierequire = formData.jindierequire?JSON.parse(formData.jindierequire):null
				next()
			},
			beforeRender(sourceData) {
				sourceData.jindierequire = sourceData.jindierequire?JSON.stringify(sourceData.jindierequire):null
			},
			// beforeInit(next){
			// 	next()
			// }
			bankaccboxBack(){
				
			},
			bankaccboxSubmit(e){
				if(e.data){
					this.fApi.setValue('corpCode',e.data.acc_code)
					this.fApi.setValue('bankAcc',e.data.inst_account)
					this.fApi.setValue('accName',e.data.acc_name)
				}
			},
			jindierequireButton(){
				let jindietype = this.fApi.getValue('jindietype')
				if(!jindietype){
					this.$message.error('请选择星空模块')
					return
				}
				let maindata = {}
				maindata.bankAcc = this.fApi.getValue('bankAcc')
				maindata.jindietype = this.fApi.getValue('jindietype')
				let $son_formalcostorder_detail = this.fApi.el('$son_formalcostorder_detail')
				let table = $son_formalcostorder_detail.getGrid()
				let fullData = table.getTableData().fullData
				let costordertype = window.systemData.emun.filter((item)=>{
					return item.field == 'costordertype'
				})
				let tabledata = fullData.map((item)=>{
					let costordertypecode = null
					let target = costordertype.find((_item)=>{
						return _item.id == item.costordertype[item.costordertype.length - 1]
					})
					if(target && target.code){
						costordertypecode = target.code.split('/')[0]
					}
					return {
						id:item.id,
						costordertype:window.systemMethods.getEmunValue('costordertype',item.costordertype),
						costordertypecode:costordertypecode,
						costamount:item.costamount,
						businessdepartmentid:item.businessdepartmentid,
						FEXPENSEDEPTID_E:null,
						FCOSTID:null,
						store:item.store,
						FSETTLETYPEID:null,
						FPURPOSEID:null,
						F_SXTN_DFKM:null,
						F_SXTN_ZZJG:null,
					}
				})
				this.tabledata = tabledata.filter((item)=>{
					return item.id
				})
				this.maindata = maindata
				//console.log(tabledata)
				this.jindierequire = this.fApi.getValue('jindierequire')
				this.$nextTick(()=>{
					this.$refs.jindieform.modal_show()
				})
				
			},
			jindietypeChange(){
				this.fApi.setValue('jindierequire',null)
			},
			jindieformSuccess(e){
				this.fApi.setValue('jindierequire',e.data)
				this.fApi.setValue('jindiestaffid',this.$store.state.system.user.id)
			},
			jindieformClear(){
				this.fApi.setValue('jindierequire',null)
			},
			bankaccboxload(){
				
			},
			rcvaccboxBack(){
				
			},
			rcvaccboxSubmit(e){
				if(e.data){
					this.fApi.setValue('rcvAcc',e.data.rcvAcc)
					this.fApi.setValue('rcvBankName',e.data.rcvBankName)
					this.fApi.setValue('rcvName',e.data.rcvName)
				}
			},
			rcvaccboxload(){
				
			},
			costobjChange(){
				if(!this.id){
					this.fApi.setValue('rcvAcc',null)
					this.fApi.setValue('rcvBankName',null)
					this.fApi.setValue('rcvName',null)
				}
			},
			amountChange(){
				if(!this.fApi.getValue('jindierequire')){
					let amount = this.fApi.getValue('amount')
					if(amount > 0){
						this.fApi.setValue('jindietype','AP_PAYBILL')
					}else{
						this.fApi.setValue('jindietype','AP_REFUNDBILL')
					}
				}
			
			},
			bankAccButton(){
				this.$refs.bankaccbox.initList()
				this.$refs.bankaccbox.box.alertBox()
			},
			rcvAccButton(){
				this.costobj = this.fApi.getValue('costobj') 
				this.businessstaffid = this.fApi.getValue('businessstaffid') 
				// if(!this.businessstaffid){
				// 	this.$message.error('请选择业务员')
				// 	return
				// }
				if(!this.costobj){
					this.$message.error('请选择费用对象')
					return
				}				
				this.$refs.rcvaccbox.initList()
				this.$refs.rcvaccbox.box.alertBox()		
			},
			
			
			tablefieldChange() {
				this.getAmount()
			},
			aftertabledelete() {
				this.getAmount()
			},
			getAmount() {
				let $son_formalcostorder_detail = this.fApi.el('$son_formalcostorder_detail')
				let table = $son_formalcostorder_detail.getGrid()
				let fullData = table.getTableData().fullData
				let amount = 0
				fullData.forEach((item) => {
					amount += parseFloat(item.costamount?item.costamount:0)
				})
				this.fApi.setValue('amount', amount)
				return amount.toFixed(2)
			},
		},
		components: {

		}
	}
</script>
